import {http} from './config';
export default{
  
    listarPerfilesPublico:()=>{
        return http.get('api/perfiles');
    }

}